// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-edit-wrapper {
    padding-top: 10px;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

.edit-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.form-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
}

.form-group label {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-main);
}

.form-control {
    width: 100%;
    height: 50px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
    font-family: inherit;
    appearance: none;
}

.form-control:focus {
    outline: none;
    background-color: #fff;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
}

.select-wrapper::after {
    content: '\\f107';
    font-family: 'FontAwesome';
    position: absolute;
    right: 16px;
    top: 38px;
    color: var(--text-muted);
    pointer-events: none;
}

.security-section {
    margin-top: 10px;
    padding-top: 24px;
    border-top: 1px dashed var(--border-light);
}

.section-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--brand-primary);
    margin: 0 0 8px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.security-desc {
    font-size: 0.9rem;
    color: var(--text-muted);
    margin: 0 0 16px 0;
    line-height: 1.5;
}

.btn-reset-link {
    background-color: var(--bg-app);
    border: 1px solid var(--brand-primary);
    color: var(--brand-primary);
    padding: 12px 20px;
    border-radius: var(--radius-input);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-reset-link:hover {
    background-color: var(--brand-primary);
    color: white;
}

.btn-reset-link:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: var(--bg-input);
    border-color: var(--border-light);
    color: var(--text-muted);
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 10px;
    padding-top: 20px;
    border-top: 1px solid var(--bg-app);
}

.btn-cancel {
    background: transparent;
    border: 1px solid var(--border-light);
    color: var(--text-muted);
    font-weight: 600;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: var(--radius-input);
    transition: all 0.2s;
}

.btn-cancel:hover {
    background-color: var(--bg-app);
    color: var(--text-main);
    border-color: var(--text-muted);
}

.btn-save {
    background-color: var(--brand-primary);
    color: #fff;
    border: none;
    padding: 12px 24px;
    border-radius: var(--radius-input);
    font-weight: 700;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-save:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0,0,0,0.15);
}

.btn-save:disabled {
    background-color: #CBD5E1;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.error-banner, .success-banner {
    padding: 12px;
    border-radius: var(--radius-md);
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
}

.success-banner {
    background-color: #DCFCE7;
    border: 1px solid #BBF7D0;
    color: #166534;
}

.spinner-small {
    width: 18px; height: 18px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.spinner-small-dark {
    width: 18px; height: 18px;
    border: 2px solid rgba(0,0,0,0.1);
    border-top-color: var(--brand-primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

@media (max-width: 500px) {
    .form-row {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProfileEditForm.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5D;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,sCAAsC;IACtC,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW,EAAE,YAAY;IACzB,uCAAuC;IACvC,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,WAAW,EAAE,YAAY;IACzB,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".profile-edit-wrapper {\n    padding-top: 10px;\n    animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n\n.edit-form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.form-group {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    position: relative;\n}\n\n.form-group label {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.form-control {\n    width: 100%;\n    height: 50px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n    font-family: inherit;\n    appearance: none;\n}\n\n.form-control:focus {\n    outline: none;\n    background-color: #fff;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n}\n\n.select-wrapper::after {\n    content: '\\f107';\n    font-family: 'FontAwesome';\n    position: absolute;\n    right: 16px;\n    top: 38px;\n    color: var(--text-muted);\n    pointer-events: none;\n}\n\n.security-section {\n    margin-top: 10px;\n    padding-top: 24px;\n    border-top: 1px dashed var(--border-light);\n}\n\n.section-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--brand-primary);\n    margin: 0 0 8px 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.security-desc {\n    font-size: 0.9rem;\n    color: var(--text-muted);\n    margin: 0 0 16px 0;\n    line-height: 1.5;\n}\n\n.btn-reset-link {\n    background-color: var(--bg-app);\n    border: 1px solid var(--brand-primary);\n    color: var(--brand-primary);\n    padding: 12px 20px;\n    border-radius: var(--radius-input);\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.btn-reset-link:hover {\n    background-color: var(--brand-primary);\n    color: white;\n}\n\n.btn-reset-link:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    background-color: var(--bg-input);\n    border-color: var(--border-light);\n    color: var(--text-muted);\n}\n\n.form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 10px;\n    padding-top: 20px;\n    border-top: 1px solid var(--bg-app);\n}\n\n.btn-cancel {\n    background: transparent;\n    border: 1px solid var(--border-light);\n    color: var(--text-muted);\n    font-weight: 600;\n    cursor: pointer;\n    padding: 10px 20px;\n    border-radius: var(--radius-input);\n    transition: all 0.2s;\n}\n\n.btn-cancel:hover {\n    background-color: var(--bg-app);\n    color: var(--text-main);\n    border-color: var(--text-muted);\n}\n\n.btn-save {\n    background-color: var(--brand-primary);\n    color: #fff;\n    border: none;\n    padding: 12px 24px;\n    border-radius: var(--radius-input);\n    font-weight: 700;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.btn-save:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(0,0,0,0.15);\n}\n\n.btn-save:disabled {\n    background-color: #CBD5E1;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.error-banner, .success-banner {\n    padding: 12px;\n    border-radius: var(--radius-md);\n    font-size: 0.9rem;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 20px;\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n}\n\n.success-banner {\n    background-color: #DCFCE7;\n    border: 1px solid #BBF7D0;\n    color: #166534;\n}\n\n.spinner-small {\n    width: 18px; height: 18px;\n    border: 2px solid rgba(255,255,255,0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n.spinner-small-dark {\n    width: 18px; height: 18px;\n    border: 2px solid rgba(0,0,0,0.1);\n    border-top-color: var(--brand-primary);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n@media (max-width: 500px) {\n    .form-row {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
